module.exports = __webpack_public_path__ + "static/media/front-right.1dc7ef07.jpg";